'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useUserDetails } from 'user-data/hooks/useUserDetails'

import {
	TIER_BENEFITS_LABELS,
	TIER_TITLE_LABELS,
} from '../../../../constants/welcomeMessage'

import texts from 'fukku/styles/texts.module.scss'

export const TierBenefits = () => {
	const { t } = useLabels()
	const userDetails = useUserDetails()

	const tierLevel = userDetails?.loyalty?.likes?.tier?.tier

	if (!tierLevel) {
		return null
	}

	return (
		<>
			<p className={texts.uppercaseL}>{t(TIER_TITLE_LABELS[tierLevel])}</p>
			<p>{t(TIER_BENEFITS_LABELS[tierLevel])}</p>
		</>
	)
}
